import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import styled from "styled-components"
import { getActiveInput, updateSeferMaliyetData } from "../../features/calc/calcSlice";
import formatConverter from "../../helper/formatConverter";
import { PiEqualsBold } from "react-icons/pi";

const Container = styled.div`
      max-width: 100%;
      width: 100%;
      overflow-x: auto;

      .table{
        width: 100%;

        tr{
        width: 100%;

            width: max-content;
        }


        .table-top{

        }
      }
`

const TableTopTitleItem = styled.th`
  background-color: var(--color-main);
  padding: 12px 10px;
  text-align: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-lg);
  color: #fff;
  border: 1px solid var(--color-main);

`;

const TableDataItem = styled.td`
  border: 1px solid ${({theme}) => theme.mainTextColor};
  background-color: ${({theme}) => theme.mainBgColor};
  font-size:  var(--font-size-sm);
  font-weight: var(--font-weight-lg);
  padding: ${({isTitle, isNumber}) => (isTitle || isNumber) ? "12px 10px" : "12px 20px"};
  text-align: ${({isTitle}) => isTitle ? "start" : "center"};
  background-color: ${({res, isDisabled, theme}) => res ? "#ff00002c" : isDisabled && theme.secondaryBgColor};

  .equal-icon{
    fill: ${({theme}) => theme.mainTextColor};
  }

    input{
        width: 100%;
        height: 100%;
        text-align: center;
        font-variant-numeric: lining-nums;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: transparent;
    }
`

const sidePropName = [
    "100 Km.'de Yakıt Tüketimi (Litre)",
    "Araç Lastik Sayısı (Adet)",
    "Lastik Ömrü (Km)",
    "Bir Adet Lastik Fiyatı(TL)",
    "Motorlu Taşıtlar Vergisi Ücreti (TL)",
    "Zorunlu Trafik Sigortası Ücreti (TL)",
    "Kasko Bedeli (TL)",
    "Yük Sigortası Yıllık (TL)",
    "Muayene Harç Bedeli (TL) (Egzoz dahil)",
    "Akü/Akülerin Toplam Fiyatı (TL)",
    "Akü Değişim Süresi (Ay Olarak)",
    "Aylık Tahmini Arıza Bakım Onarım Yağ Değişim Tutarı (TL)",
    "Araç Sahibi Aylık SGK veya Bağkur Ödemesi (TL)",
    "Sürücü Brüt Maaşı (TL)",
    "Sürücü Günlük Harcırah Giderleri (TL)",
    "Diğer Giderler (Aylık)(TL) Muhasebe-Komisyon-Garaj-Otopark-Yıkama vb. giderler",
    "Maksimum Yük Tonajı (Ton)",
    "Boş Yükte Yakıt Tüketimi (100 Km'de)",
    "Full Yükte Yakıt Tüketimi (100 Km'de)",
    "1 Km'lik Maliyet",
    "1 Günlük Maliyet",
    "Son Güncelleme Tarihi"
  ]

  const topPropName = ["", "Maliyet Kriterleri", "Tır", "Kırkayak", "10 Teker", "6 Teker", "Kamyonet", "Panelvan", "Kamyon Römork"]
  
  const SeferMaliyetTable = () => {

    const {
        seferMaliyetData,
        activeInput,

    } = useSelector(state => state.calc)

    const dispatch = useDispatch()

 

    const handleChange = (e, item, key) => {

        dispatch(updateSeferMaliyetData({
            value: e.target.value.replace(/[^0-9]/g, ''),
            id: item.id,
            key
        }))
        
    }

    useEffect(() => {
        return () => {
            dispatch(getActiveInput(null))
        }
    },[])


  return (
    <Container>
        <table className="table">
            <thead className="thead">
                <tr>
                    {
                        topPropName.map((item, i) => (
                            <TableTopTitleItem key={i}>{item}</TableTopTitleItem>
                        ))
                    }
                </tr>
            </thead>
            <tbody className="tbody">

                {/* //! 100 Km de yakıt Tüketimi */}
                <tr>
                        <TableDataItem isNumber={true}>1</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[0]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                litreYakıtTuketimi100Km: item.litreYakıtTuketimi100Km,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"litreYakıtTuketimi100Km") ? item.litreYakıtTuketimi100Km : (item.litreYakıtTuketimi100Km).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "litreYakıtTuketimi100Km")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"litreYakıtTuketimi100Km"))}}/></TableDataItem>
                        ))
                    }
                </tr>


                {/* //! Araç Lastik Sayısı (Adet) */}
                <tr>
                        <TableDataItem isNumber={true}>2</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[1]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                wheelCount: item.aracTuru.wheelCount,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem isDisabled={true} key={i}>{item.wheelCount}</TableDataItem>
                        ))
                    }
                </tr>

                {/* //! Lastik Ömrü (Km) */}
                <tr>
                        <TableDataItem isNumber={true}>3</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[2]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                lastikOmruKm: item.lastikOmruKm,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"lastikOmruKm") ? item.lastikOmruKm : (item.lastikOmruKm).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "lastikOmruKm")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"lastikOmruKm"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                {/* //! Bir Adet Lastik Fiyatı(TL) */}
                <tr>
                        <TableDataItem isNumber={true}>4</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[3]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                birAdetLastikUcreti: item.birAdetLastikUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"birAdetLastikUcreti") ? item.birAdetLastikUcreti : (item.birAdetLastikUcreti).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "birAdetLastikUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"birAdetLastikUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                {/* //! Motorlu Taşıtlar Vergisi Ücreti (TL) */}
                <tr>
                        <TableDataItem isNumber={true}>5</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[4]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                motorluTasitlarVergisiUcreti: item.motorluTasitlarVergisiUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"motorluTasitlarVergisiUcreti") ? item.motorluTasitlarVergisiUcreti : (item.motorluTasitlarVergisiUcreti).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "motorluTasitlarVergisiUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"motorluTasitlarVergisiUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                {/* //! Zorunlu Trafik Sigortası Ücreti (TL) */}
                <tr>
                        <TableDataItem isNumber={true}>6</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[5]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                zorunluTrafikSigortasiUcreti: item.zorunluTrafikSigortasiUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"zorunluTrafikSigortasiUcreti") ? item.zorunluTrafikSigortasiUcreti : (item.zorunluTrafikSigortasiUcreti).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "zorunluTrafikSigortasiUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"zorunluTrafikSigortasiUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                {/* //! "Kasko Bedeli (TL) */}
                <tr>
                        <TableDataItem isNumber={true}>7</TableDataItem>
                        <TableDataItem isTitle={true}>{sidePropName[6]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                kaskoUcreti: item.kaskoUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"kaskoUcreti") ? item.kaskoUcreti : (item.kaskoUcreti)?.toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "kaskoUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"kaskoUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                {/* //!Yük Sigortası Yıllık (TL) */}
                <tr>
                    <TableDataItem isNumber={true}>8</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[7]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                yukSigortasiYillik: item.yukSigortasiYillik,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"yukSigortasiYillik") ? item.yukSigortasiYillik : (item.yukSigortasiYillik).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "yukSigortasiYillik")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"yukSigortasiYillik"))}}/></TableDataItem>
                        ))
                    }
                </tr>



                {/* //! Muayene Harç Bedeli (TL) (Egzoz dahil) */}
                <tr>
                    <TableDataItem isNumber={true}>9</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[8]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                muayeneHarcBedeli: item.muayeneHarcBedeli,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"muayeneHarcBedeli") ? item.muayeneHarcBedeli : (item.muayeneHarcBedeli).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "muayeneHarcBedeli")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"muayeneHarcBedeli"))}}/></TableDataItem>
                        ))
                    }
                </tr>



                {/* //! Akü/Akülerin Toplam Fiyatı (TL) */}
                <tr>
                    <TableDataItem isNumber={true}>10</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[9]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                akulerinToplamUcreti: item.akulerinToplamUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"akulerinToplamUcreti") ? item.akulerinToplamUcreti : (item.akulerinToplamUcreti).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "akulerinToplamUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"akulerinToplamUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>


                {/* //! Akü Değişim Süresi (Ay Olarak) */}
                <tr>
                    <TableDataItem isNumber={true}>11</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[10]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                akuDegisimSuresiAyOlarak: item.akuDegisimSuresiAyOlarak,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"akuDegisimSuresiAyOlarak") ? item.akuDegisimSuresiAyOlarak : (item.akuDegisimSuresiAyOlarak).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "akuDegisimSuresiAyOlarak")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"akuDegisimSuresiAyOlarak"))}}/></TableDataItem>
                        ))
                    }
                </tr>


               {/* //! Aylık Tahmini Arıza Bakım Onarım Yağ Değişim Tutarı (TL) */}
               <tr>
                    <TableDataItem isNumber={true}>12</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[11]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                aylikTahminiArizaBakimOnarimYagDegisimTutarı: item.aylikTahminiArizaBakimOnarimYagDegisimTutarı,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id + item.order)?.toString()+"aylikTahminiArizaBakimOnarimYagDegisimTutarı") ? item.aylikTahminiArizaBakimOnarimYagDegisimTutarı : (item.aylikTahminiArizaBakimOnarimYagDegisimTutarı).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "aylikTahminiArizaBakimOnarimYagDegisimTutarı")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id + item.order)?.toString()+"aylikTahminiArizaBakimOnarimYagDegisimTutarı"))}}/></TableDataItem>
                        ))
                    }
                </tr>



                {/* //! Araç Sahibi Aylık SGK veya Bağkur Ödemesi (TL) */}
                <tr>
                    <TableDataItem isNumber={true}>13</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[12]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                aracSahibiAylikSgkBagkurOdemesi: item.aracSahibiAylikSgkBagkurOdemesi,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"aracSahibiAylikSgkBagkurOdemesi") ? item.aracSahibiAylikSgkBagkurOdemesi : (item.aracSahibiAylikSgkBagkurOdemesi).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "aracSahibiAylikSgkBagkurOdemesi")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"aracSahibiAylikSgkBagkurOdemesi"))}}/></TableDataItem>
                        ))
                    }
                </tr>


                {/* //! Sürücü Brüt Maaşı (TL) */}
                <tr>
                    <TableDataItem isNumber={true}>14</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[13]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                surucuVarsaMaasBrut: item.surucuVarsaMaasBrut,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"surucuVarsaMaasBrut") ? item.surucuVarsaMaasBrut : (item.surucuVarsaMaasBrut).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "surucuVarsaMaasBrut")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"surucuVarsaMaasBrut"))}}/></TableDataItem>
                        ))
                    }
                </tr>



                {/* //! Sürücü Günlük Harcırah Giderleri (TL) */}
                <tr>
                    <TableDataItem isNumber={true}>15</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[14]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                surucuHarcirahGiderlerAylikUcreti: item.surucuHarcirahGiderlerAylikUcreti,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"surucuHarcirahGiderlerAylikUcreti") ? item.surucuHarcirahGiderlerAylikUcreti : (item.surucuHarcirahGiderlerAylikUcreti).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "surucuHarcirahGiderlerAylikUcreti")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"surucuHarcirahGiderlerAylikUcreti"))}}/></TableDataItem>
                        ))
                    }
                </tr>




                {/* //! Diğer Giderler (Aylık)(TL) Muhasebe-Komisyon-Garaj-Otopark-Yıkama vb. giderler */}
                <tr>
                    <TableDataItem isNumber={true}>16</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[15]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                digerGiderler: item.digerGiderler,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"digerGiderler") ? item.digerGiderler : (item.digerGiderler).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "digerGiderler")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"digerGiderler"))}}/></TableDataItem>
                        ))
                    }
                </tr>



                {/* //! Maksimum Yük Tonajı (Ton) */}
                <tr>
                    <TableDataItem isNumber={true}>17</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[16]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                maksimumYukTonaji: item.maksimumYukTonaji,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"maksimumYukTonaji") ? item.maksimumYukTonaji : (item.maksimumYukTonaji).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "maksimumYukTonaji")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"maksimumYukTonaji"))}}/></TableDataItem>
                        ))
                    }
                </tr>


                {/* //! Boş Yükte Yakıt Tüketimi (100 Km'de) */}
                <tr>
                    <TableDataItem isNumber={true}>18</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[17]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                bos100KmYakitTuketimi: item.bos100KmYakitTuketimi,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"bos100KmYakitTuketimi") ? item.bos100KmYakitTuketimi : (item.bos100KmYakitTuketimi).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "bos100KmYakitTuketimi")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"bos100KmYakitTuketimi"))}}/></TableDataItem>
                        ))
                    }
                </tr>


                {/* //! Full Yükte Yakıt Tüketimi (100 Km'de) */}
                <tr>
                    <TableDataItem isNumber={true}>19</TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[18]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                fullTonaj100KmYakitTuketimi: item.fullTonaj100KmYakitTuketimi,
                                id: item.id,
                                order: i
                            }
                        }).map((item, i) => (
                            <TableDataItem key={i}><input value={activeInput === ((item.id)?.toString()+"fullTonaj100KmYakitTuketimi") ? item.fullTonaj100KmYakitTuketimi : (item.fullTonaj100KmYakitTuketimi).toLocaleString("tr-TR") } onChange={(e) => handleChange(e, item, "fullTonaj100KmYakitTuketimi")} onClick={(e) => {e.stopPropagation(); dispatch(getActiveInput((item.id)?.toString()+"fullTonaj100KmYakitTuketimi"))}}/></TableDataItem>
                        ))
                    }
                </tr>

                   {/* //! 1 Km'lik Maliyet */}
                   <tr>
                    <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[19]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                kmMaliyet: item.kmMaliyet,
                            }
                        }).map((item, i) => (
                            <TableDataItem res={true} key={i}>{formatConverter(item.kmMaliyet, 2)}</TableDataItem>
                        ))
                    }
                </tr>

                {/* //! 1 Günlük Maliyet */}
                <tr>
                    <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[20]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                gunlukMaliyet: item.gunlukMaliyet,
                            }
                        }).map((item, i) => (
                            <TableDataItem res={true} key={i}>{formatConverter(item.gunlukMaliyet, 2)}</TableDataItem>
                        ))
                    }
                </tr>

                {/* //! Son Güncelleme Tarihi */}
                <tr>
                    <TableDataItem isNumber={true}><PiEqualsBold className="equal-icon"/></TableDataItem>
                    <TableDataItem isTitle={true}>{sidePropName[21]}</TableDataItem>
                    {
                        seferMaliyetData.map((item,i) => {
                            return {
                                olusturulmaTarihi: item.olusturulmaTarihi,
                            }
                        }).map((item, i) => (
                            <TableDataItem res={true} key={i}>{item.olusturulmaTarihi}</TableDataItem>
                        ))
                    }
                </tr>

            </tbody>
        </table>
    </Container>
  )
}

export default SeferMaliyetTable